module.exports = __webpack_public_path__ + "img/charge.14a5eca8.png";